import { useContext, useEffect, useState } from "react";
import useOffer from "../../api/hooks/useOffers";
import EarningsChart from "../../components/chart/EarningsChart";
import MyNavigator from "../../components/misc/MyNavigator";
import NavBar from "../../components/misc/NavBar";
import SideBar from "../../components/misc/SideBar";
import EarningsSideBar from "../../components/overview/EarningsSideBar";
import OpenOfferTag from "../../components/overview/OpenOfferTag";
import OverviewHeader from "../../components/overview/OverviewHeader";
import OverviewNews from "../../components/overview/OverviewNews";
import { cookieName } from "../../consts/cookie";
import { possible_statuses } from "../../consts/possible_statuses";
import MainContext from "../../context/MainContext";
import useIsMobile from "../../hooks/useIsMobile";
import useToggle from "../../hooks/useToggle";
import { Offer } from "../../interfaces";
import "../../styles/General.css";
import "../../styles/News.css";
import "../../styles/Overview.css";
import { deleteCookie, getCookie } from "../../utils/handleCookie";

const OverviewPage = (props: any) => {
  /*   
  // unmute / mute these, or delete browser chronology to test tips card workflow
  deleteCookie(cookieName.tip_1);
  deleteCookie(cookieName.tip_2);
  deleteCookie(cookieName.tip_3);
  */

  const tipsRemoveCondition =
    getCookie(cookieName.tip_1) === "false" &&
    getCookie(cookieName.tip_2) === "false" &&
    getCookie(cookieName.tip_3) === "false";

  const navigateNow = useToggle(false);
  const { isMobile } = useIsMobile();
  const menuToggler = useToggle(false);
  const newsToggler = useToggle(false);

  const { token, refresh } = useContext(MainContext);

  const offerHook = useOffer();

  const [allOffers, setAllOffers] = useState<Offer[]>([]);
  const [offerFetched, setOfferFetched] = useState<Offer[]>([]);

  useEffect(() => {
    offerHook.CTAs.getOffersListAll();
  }, [refresh]);

  useEffect(() => {
    /* console.log(
      offerHook.RESPONSES.getOffersListAllResponse,
      offerHook.RESULTS.getOffersListAllResult, 
    );   */
    if (offerHook.RESPONSES.getOffersListAllResponse?.ok && token) {
      setAllOffers(offerHook.RESULTS.getOffersListAllResult.offerts);
      const tempArray = offerHook.RESULTS.getOffersListAllResult.offerts
        .filter((offer: any) => offer.status === possible_statuses.offer.open)
        .slice(0, 3); /* show the first 3 open offers */
      setOfferFetched(tempArray);
    }
  }, [offerHook.RESPONSES.getOffersListAllResponse]);

  const renderOpenOffersTags = offerFetched.map((offer, key) => {
    return <OpenOfferTag key={key} offer={offer} />;
  });

  return (
    <div className="page-wrapper">
      <MyNavigator path={`/offers`} trigger={navigateNow} />
      {(!isMobile || menuToggler.isToggled) && (
        <SideBar toggler={menuToggler} />
      )}
      <div style={{ width: "100%" }}>
        {isMobile && <NavBar toggler={menuToggler} />}
        <div
          className={`page-content ${
            isMobile && menuToggler.isToggled
              ? menuToggler.isToggledSecondary
                ? "slide-right"
                : "slide-left"
              : ""
          }`}
          style={{
            maxWidth: isMobile ? "" : "calc(100vw - 656px)",
            minWidth: isMobile ? "" : "658px",
            marginLeft: isMobile
              ? menuToggler.isToggled
                ? "256px"
                : ""
              : "256px",
          }}
        >
          <OverviewHeader />
          {!newsToggler.isToggled && !tipsRemoveCondition && (
            <OverviewNews toggler={newsToggler} />
          )}
          <div
            className="overview-offers-earning-container"
            style={{
              flexDirection: isMobile ? "column" : "row",
              margin: isMobile
                ? "38.3px auto"
                : `${
                    !newsToggler.isToggled && !tipsRemoveCondition
                      ? "386px"
                      : "0"
                  } auto 44px`,
              padding: isMobile ? "0" : "",
            }}
          >
            <div
              className={`overview-offers shadow`}
              style={{ width: isMobile ? "345px" : "" }}
            >
              <p className="overview-offers-earning-title">Open offers</p>
              {renderOpenOffersTags}
            </div>
            <div
              className={`overview-earning shadow`}
              style={{ width: isMobile ? "345px" : "" }}
            >
              <p className="overview-offers-earning-title">Earning</p>
              <div
                className={`overview-earning-inner-wrapper`} /* 
              style={{ width: isMobile ? "345px" : "" }} */
              >
                <div className="overview-earning-chart-wrapper">
                  {
                    <EarningsChart
                      width={232}
                      height={200}
                      allOffers={allOffers}
                    />
                  }
                </div>
                <button
                  className="overview-earning-button"
                  onClick={navigateNow.toggle}
                >
                  <p className="overview-earning-button-text">View Offers</p>
                </button>
              </div>
            </div>
          </div>
          {isMobile && <EarningsSideBar allOffers={allOffers} />}
        </div>
      </div>
      {!isMobile && <EarningsSideBar allOffers={allOffers} />}
    </div>
  );
};
export default OverviewPage;
